<template>
  <vx-card no-shadow>
    <div class="vx-row mb-6">
      <label class="text-sm ml-4">Store Name</label>
      <div class="vx-col w-full">
        <vs-input class="w-full" 
                  name="store name" 
                  v-model="current_organization.name" 
                  v-validate="{ required: true, regex: /^[A-Za-z\d\ \.\:]+$/, min: 5, max: 255 }"
                  data-vv-validate-on="blur">
        </vs-input>
        <span class="text-danger text-sm float-left" >{{ errors.first('store name') }}</span> 
      </div>
    </div>

    <div class="vx-row mb-6">
      <label class="text-sm ml-4">Subdomain</label>
      <div class="vx-col w-full">
        <vx-input-group>
          <vs-input
            v-validate="'required|alpha_num|min:5|max:255'"
            data-vv-validate-on="blur" 
            name="sub domain"
            v-model="current_organization.subdomain" 
            />

            <template slot="append">
              <div class="append-text bg-primary">
                <span>.quicksend.asia</span>
              </div>
            </template>
        </vx-input-group>
        <span class="text-danger text-sm float-left" >{{ errors.first('sub domain') }}</span>
      </div>
    </div>


    <div class="input-div mb-10">
      <div>
        <vx-tooltip text="This is an estimation of how many sales person can be invited">
          <vs-input-number disabled
            v-validate="'required|numeric|max:3'"
            name="sales agent"
            v-model="current_organization.sales_agent" 
            label="Sales/Agent Count:"
            class="w-full mt-6"
            size="large"/>
        </vx-tooltip>
      </div>
      <span class="text-danger text-sm float-left" >{{ errors.first('sales agent') }}</span>
    </div>


    <!-- Save & Reset Button -->
    <div class="flex flex-wrap items-center justify-end">
      <vs-button class="ml-auto mt-2" :disabled="disableSave" @click="saveChanges">Save Changes</vs-button>
      <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">Reset</vs-button>
    </div>
  </vx-card>
</template>

<script>
import axios from '@/axios';


const notifs = {
  error: (msg) => {
    return {
      title: 'Error',
      text: msg,
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'danger'
    }
  },

  success: (msg) => {
    return {
      title: 'Success',
      text: msg,
      iconPack: 'feather',
      icon: 'icon-check-circle',
      color: 'success'
    }
  },

  warning: (msg) => {
    return {
      title: 'Warning',
      text: msg,
      iconPack: 'feather',
      icon: 'icon-alert-circle',
      color: 'warning'
    }
  },
}

export default {
  data () {
    let data = {
      current_organization: {
        name: '',
        subdomain: '',
        sales_agent: 0
      },

      old_data: {
        name: '',
        subdomain: '',
        sales_agent: 0
      }
    }

    return data;
  },

  computed: {
    disableSave() {
      return this.errors.any();
    }
  },

  methods: {

    async saveChanges() {
      // check if subodomain exists
      let data_changed = false;

      if (this.old_data.subdomain !== this.current_organization.subdomain) {
        let subdomain_exists = true;
        try {
          let res = await axios.get(`/organization?subdomain=${this.current_organization.subdomain}`);
        } catch(err) {
          if (err.status === 404) subdomain_exists = false;
        }

        if (subdomain_exists) {
          this.$vs.notify(notifs.error("Subdomain already used"));
          return;
        }

        data_changed = true;
      }

      if (this.old_data.name !== this.current_organization.name) {
        let name_exists = true;
        try {
          let res = await axios.get(`/organization?name=${this.current_organization.name}`);
        } catch (err) {
          if (err.status === 404) name_exists = false;
        }

        if (name_exists) {
          this.$vs.notify(notifs.error("Store Name already used"))
        }

        data_changed = true;
      }

      if (this.old_data.sales_agent !== this.current_organization.sales_agent) {
        data_changed = true;
      }

      if (data_changed) {
        let org_id = this.$store.state.user.current_organization;
        try {
          await this.$store.dispatch('organization/updateDetails', {
            data: this.current_organization,
            organization_id: org_id
          });
          this.$vs.notify(notifs.success("Organization details successfully updated."));
          this.current_organization = this.$store.state.organization.current_organization[0]
        } catch(e) {
          this.$vs.notify(notifs.error("Cannot save store detail"));
        }
      } else {
          this.$vs.notify(notifs.warning("Settings were not changed. Nothing to save."));
      }
    },

    reset () {
      this.current_organization = this.old_data;
    }
  },

  async created() {
    // make sure data loaded from other components (profiledropdown)
    do {
      this.current_organization = _.cloneDeep(this.$store.state.organization.current_organization[0]);
      await new Promise(r => setTimeout(r, 300));
    } while (typeof this.current_organization === 'undefined');

    this.old_data = JSON.parse(JSON.stringify(this.current_organization));
  }
}
</script>
